<template>
  <div>
    <div v-if="alertKind === 'success' && alertAction === 'store'">
      <Alert
        v-model="alertKind"
        :icon="['far', 'info-circle']"
        :timeout="seconds + 1"
      >
        {{ isBeingEdited ? 'This email testing has been updated succesfully.' : 'A new email testing has been added.' }} <span v-html="closeMessage" />
      </Alert>
    </div>
    <div v-else-if="alertKind === 'success' && alertAction === 'deletion'">
      <Alert
        v-model="alertKind"
        :icon="['far', 'info-circle']"
        :timeout="seconds + 1"
      >
        The email testing has been deleted succesfully. <span v-html="closeMessage" />
      </Alert>
    </div>
    <div v-else>
      <div v-if="alertKind === 'danger' && alertAction === 'general_error'">
        <Alert
          v-model="alertKind"
          :icon="['far', 'info-circle']"
        >
          An error has occurred while processing your request. Please contact <a href="mailto:producthelp@cendyn.com">producthelp@cendyn.com</a> for assistance. <span v-html="closeMessage" />
        </Alert>
      </div>
      <div v-else />
      <div class="row">
        <div class="col-12">
          <div class="form-row">
            <div
              :class="['form-group', 'col-md-12', 'required', {error: 'firstName' in errors}]"
            >
              <ejs-textbox
                v-model="form.firstName"
                float-label-type="Always"
                placeholder="First Name"
                :css-class="errors.firstName.length ? 'e-error' : ''"
                :blur="(args) => onFieldBlur('firstName', args)"
              />
              <div
                v-if="errors.firstName.length"
                class="error"
              >
                {{ errors.firstName }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-12">
          <div class="form-row">
            <div
              :class="['form-group', 'col-md-12', 'required', {error: 'lastName' in errors}]"
            >
              <ejs-textbox
                v-model="form.lastName"
                float-label-type="Always"
                placeholder="Last Name"
                :css-class="errors.lastName.length ? 'e-error' : ''"
                :blur="(args) => onFieldBlur('lastName', args)"
              />
              <div
                v-if="errors.lastName.length"
                class="error"
              >
                {{ errors.lastName }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-12">
          <div class="form-row">
            <div
              :class="['form-group', 'col-md-12', 'required', {error: 'email' in errors}]"
            >
              <ejs-textbox
                v-model="form.email"
                float-label-type="Always"
                placeholder="Email"
                :css-class="errors.email.length ? 'e-error' : ''"
                :blur="(args) => onFieldBlur('email', args)"
              />
              <div
                v-if="errors.email.length"
                class="error"
              >
                {{ errors.email }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="form.seedListType && form.seedListType.toLowerCase() === 'test'"
        class="row mt-1"
      >
        <div class="col-12">
          <div class="form-row">
            <div
              :class="['form-group', 'col-md-12', 'required', {error: 'recipientTypeID' in errors}]"
            >
              <label for="recipientTypeID">Recipient Type</label>
              <select
                id="recipientTypeID"
                v-model="form.recipientTypeID"
                class="form-control custom-select"
              >
                <option
                  v-for="item in recipientList"
                  :key="item.id"
                  :value="item.id"
                  :checked="item.checked"
                >
                  {{ item.text }}
                </option>
              </select>
              <div
                v-if="errors.recipientTypeID.length"
                class="error"
              >
                {{ errors.recipientTypeID }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="form.seedListType && form.seedListType.toLowerCase() === 'global'"
        class="row mt-1"
      >
        <div class="col-12">
          <div class="form-row">
            <div
              :class="['form-group', 'col-md-12', 'required', {error: 'active' in errors}]"
            >
              <ejs-checkbox
                v-model="form.active"
                label="Active"
                :css-class="errors.email.length ? 'e-primary e-error' : 'e-primary'"
                checked="true"
              />
              <div
                v-if="errors.active.length"
                class="error"
              >
                {{ errors.active }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <button
          class="btn btn-lg btn-outline-secondary dialogBtnDelete"
          tabindex="-1"
          :disabled="form.id === 0"
          @click="remove"
        >
          Delete
        </button>
        <button
          class="btn btn-lg btn-outline-secondary dialogBtnCancel"
          tabindex="-1"
          @click="cancel"
        >
          Cancel
        </button>
        <button
          class="btn btn-lg btn-primary dialogBtnSubmit"
          tabindex="-1"
          @click="save"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Alert from '@/components/Alert'

export default {
  components: {
    Alert
  },
  props: {
    seconds: {
      type: Number,
      required: false,
      default: 3
    }
  },
  data () {
    return {
      userEmail: this.$route.query.userEmail ? atob(this.$route.query.userEmail) : '',
      isBeingEdited: false,
      alertSeconds: this.seconds,
      alertKind: '',
      alertAction: '',
      alertInterval: null,
      recipientList: [
        {
          text: 'Internal',
          id: 1,
          checked: true
        },
        {
          text: 'External',
          id: 2,
          checked: false
        }
      ],
      form: {
        id: 0,
        companyID: parseInt(this.$route.query.externalId),
        firstName: '',
        lastName: '',
        email: '',
        listTitle: '',
        active: true,
        seedListType: '',
        recipientTypeID: 1
      },
      errors: {
        firstName: '',
        lastName: '',
        email: '',
        recipientTypeID: '',
        active: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      emailTesting: 'getEmailTesting',
      emailTestingOnEdition: 'getEmailTestingOnEdition',
      emailTestingEditingModalIsOpen: 'getEmailTestingEditingModalIsOpen'
    }),
    hasErrors () {
      let nErrors = 0
      Object.keys(this.errors).forEach(key => {
        if (this.errors[key].length) nErrors++
      })
      return nErrors > 0
    },
    currentRecipientType () {
      const current = this.recipientList.find(item => item.id === this.form.recipientTypeID)
      return current ? current.text : 'Please select a Recipient Type'
    },
    closeMessage () {
      return `This dialog will automatically close in <strong>${this.alertSeconds}</strong> seconds.`
    }
  },
  watch: {
    emailTestingOnEdition (newVal) {
      if (newVal !== null) {
        this.form.listTitle = newVal.listTitle
        this.form.seedListType = newVal.seedListType
        if ('beid' in newVal) {
          this.isBeingEdited = true
          this.form.id = newVal.beid
          this.form.companyID = newVal.companyID
          this.form.firstName = newVal.firstName
          this.form.lastName = newVal.lastName
          this.form.email = newVal.email
          this.form.active = newVal.active
          this.form.recipientTypeID = newVal.recipientTypeID
        } else {
          this.isBeingEdited = false
          this.form.id = 0
          this.form.companyID = parseInt(this.$route.query.externalId)
          this.form.firstName = ''
          this.form.lastName = ''
          this.form.email = ''
          this.form.active = true
          this.form.recipientTypeID = 1
        }
      }
    },
    emailTestingEditingModalIsOpen (newVal) {
      if (!newVal) {
        this.alertKind = ''
        this.alertAction = ''
        clearInterval(this.alertInterval)
        this.alertSeconds = this.seconds
      }
    }
  },
  methods: {
    ...mapActions([
      'getSeedList',
      'addSeedListRecipient',
      'deleteSeedListRecipient',
      'updateSeedListRecipient'
    ]),
    onDropdownSelect ({ item }) {
      const selectedItem = this.recipientList.find(option => option.name === item.name)
      if (selectedItem) {
        this.form.recipientTypeID = selectedItem
      }
    },
    onFieldBlur (field, args) {
      this.validateField(field)
    },
    validateField (field = '') {
      // const { name, linkTagging, tags, description } = this.form
      if (!(field in this.form) || typeof this.form[field] === 'undefined') return

      switch (field) {
        case 'firstName': {
          const { firstName } = this.form
          this.errors[field] = this.$validation.isEmpty(firstName, 'The First Name field is required') || this.$validation.minLength(firstName, 2, 'The First Name should have at least [MIN] characters') || this.$validation.maxLength(firstName, 255, 'The First Name should have at most [MAX] characters')
        }
          break
        case 'lastName': {
          const { lastName } = this.form
          this.errors[field] = this.$validation.isEmpty(lastName, 'The Last Name field is required') || this.$validation.minLength(lastName, 2, 'The Last Name should have at least [MIN] characters') || this.$validation.maxLength(lastName, 255, 'The Last Name should have at most [MAX] characters')
        }
          break
        case 'email': {
          const { email } = this.form
          // const sameEmail = email.toLowerCase() === this.userEmail.toLowerCase() ? 'Can\'t add your email' : ''
          this.errors[field] = this.$validation.isEmpty(email, 'The Email field is required') || this.$validation.isEmail(email) || this.$validation.maxLength(email, 255, 'The Email should have at most [MAX] characters')
        }
          break
      }
    },
    validateForm () {
      this.validateField('firstName')
      this.validateField('lastName')
      this.validateField('email')
    },
    cancel () {
      this.clearForm()
      this.alertKind = ''
      this.alertAction = ''
      if (this.emailTesting.manageModalRef) {
        this.emailTesting.manageModalRef.closeDialog()
      }
    },
    clearForm () {
      this.form.id = 0
      this.form.companyID = parseInt(this.$route.query.externalId)
      this.form.firstName = ''
      this.form.lastName = ''
      this.form.email = ''
      this.form.listTitle = ''
      this.form.active = true
      this.form.seedListType = ''
      this.form.recipientTypeID = 1

      this.errors.firstName = ''
      this.errors.lastName = ''
      this.errors.email = ''
      this.errors.recipientType = ''
      this.errors.active = ''
    },
    save () {
      this.validateForm()
      if (!this.hasErrors) {
        const userEmail = this.$route.query.userEmail ? atob(this.$route.query.userEmail) : ''
        const data = { ...this.form }
        data.email = data.email.toLowerCase()
        if (data.id) {
          this.updateSeedListRecipient({ recipientId: data.id, userEmail, data })
            .then(response => {
              if (response === 0) {
                data.pid = data.seedListType
                data.id = data.email
                // console.log('updateSeedListRecipient: ', data)
                this.getSeedList({ userEmail })
                this.alertKind = 'success'
                this.alertAction = 'store'
                this.startCountdown()
                this.clearForm()
                setTimeout(() => {
                  this.cancel()
                }, this.seconds * 1000)
              } else if (response === 2) {
                this.errors.email = 'Email already exists'
              } else {
                this.alertKind = 'danger'
                this.alertAction = 'general_error'
              }
            })
            .catch(err => {
              console.log(err)
              this.alertKind = 'danger'
              this.alertAction = 'general_error'
            })
        } else {
          this.addSeedListRecipient({ userEmail, data })
            .then(response => {
              if (response === 0) {
                // console.log('addSeedListRecipient: ', data)
                this.getSeedList({ userEmail })
                this.alertKind = 'success'
                this.alertAction = 'store'
                this.startCountdown()
                this.clearForm()
                setTimeout(() => {
                  this.cancel()
                }, this.seconds * 1000)
              } else if (response === 2) {
                this.errors.email = 'Email already exists'
              } else {
                this.alertKind = 'danger'
                this.alertAction = 'general_error'
              }
            })
            .catch(err => {
              console.log(err)
              this.alertKind = 'danger'
              this.dangerAlertMsg = 'general_error'
            })
        }
      }
    },
    remove () {
      const userEmail = this.$route.query.userEmail ? atob(this.$route.query.userEmail) : ''
      this.deleteSeedListRecipient({ recipientId: this.form.id, listType: this.emailTestingOnEdition.seedListType, userEmail, data: this.form })
        .then(response => {
          this.getSeedList({ userEmail })
          this.alertKind = 'success'
          this.alertAction = 'deletion'
          this.startCountdown()
          this.clearForm()
          setTimeout(() => {
            this.cancel()
          }, this.seconds * 1000)
        })
        .catch(err => {
          console.log(err)
          this.alertKind = 'danger'
          this.dangerAlertMsg = 'general_error'
        })
    },
    startCountdown () {
      this.alertInterval = setInterval(() => {
        if (this.alertSeconds > 0) {
          this.alertSeconds--
        } else {
          clearInterval(this.alertInterval)
          this.alertSeconds = this.seconds
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/@syncfusion/ej2-base/styles/bootstrap4.css';
  @import '../../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap4.css';
  @import '../../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap4.css';

  .template-creator {
    position: relative;
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    display: none;
    background-color: #ffffffcf;
    &.active {
      display: block;
    }
  }

  .custom-select {
    height: 29px;
  }

  .divider {
    border-bottom: 1px solid $gray-light;
  }

  .error {
    color: $red;
  }

  .e-float-input input, .e-float-input.e-control-wrapper input, .e-float-input textarea, .e-float-input.e-control-wrapper textarea {
    border-radius: 2px;
  }
  .e-btn-primary {
    border-radius: 2px;
    color: $white;
    background-color: $bocalipstick;
    border-color: $bocalipstick-dark;
  }
</style>
